import { ApiService, useAuthStore } from '@supply-mover-2-0/core';

import { QBO_STATE_KEY } from '../oauth-callback.constants';
import type {
	OAuthCallbackParams,
	OAuthCallbackResult,
	OAuthHandler,
} from '../oauth-callback.types';

export const QboOAuthHandler: OAuthHandler = {
	name: 'qbo',

	canHandle(params: OAuthCallbackParams): boolean {
		const { code, state, realmId } = params;

		if (code == null || state == null || realmId == null) {
			return false;
		}

		const storedState = useAuthStore.getState().qboOAuthState;

		return storedState === state;
	},

	async handle(params: OAuthCallbackParams): Promise<OAuthCallbackResult> {
		const { code, state, realmId } = params;

		if (code == null || state == null || realmId == null) {
			return {
				success: false,
				error: 'Missing authorization code, state, or realmId',
			};
		}

		try {
			await ApiService.apiPost('/integrations/qbo/auth/callback', {
				code,
				realmId,
				state,
			});

			useAuthStore.getState().setQboOAuthState(null);

			return {
				success: true,
				redirectTo: '/settings/integrations',
			};
		} catch (err) {
			console.error('Error handling QBO callback:', err);

			return {
				success: false,
				error: 'Failed to connect QuickBooks. Please try again.',
			};
		}
	},

	getStorageKey(): string {
		return QBO_STATE_KEY;
	},
};
